<div class="cookies-page">
  <div class="cookie-header">
    <h1 class="cookie-header__title">{{ 'cookies-page.title' | translate }}</h1>
    <hr class="cookie-header__separator" />
    <div class="cookie-header__introduction">
      <p>
        {{ 'cookies-page.message-01' | translate }}
      </p>
      <p>
        {{ 'cookies-page.message-02' | translate }}
      </p>
    </div>
  </div>

  <div class="cookie-content">

    <div>
      <h3 class="cookie-content__title">
        {{ 'cookies-page.message-03' | translate }}
      </h3>
      <p>{{ 'cookies-page.message-04' | translate }}</p>
      <p>{{ 'cookies-page.message-05' | translate }}</p>

      <ul class="cookie-content__list cookie-content__list--types">
        <li>{{ 'cookies-page.cookie-expiration' | translate }}</li>
        <ul>
          <li>{{ 'cookies-page.session' | translate }}</li>
          <li>{{ 'cookies-page.persistence' | translate }}</li>
        </ul>

        <li>{{ 'cookies-page.cookie-origin' | translate }}</li>
        <ul>
          <li>{{ 'cookies-page.origin' | translate }}</li>
          <li>{{ 'cookies-page.third-party' | translate }}</li>
        </ul>

        <li>{{ 'cookies-page.cookie-purpose' | translate }}</li>
        <ul>
          <li>{{ 'cookies-page.technical' | translate }}</li>
          <li>{{ 'cookies-page.customization' | translate }}</li>
          <li>{{ 'cookies-page.analysis' | translate }}</li>
          <li>{{ 'cookies-page.advertising' | translate }}</li>
          <li>{{ 'cookies-page.behavioral-advertising' | translate }}</li>
        </ul>
      </ul>
    </div>

    <div class="cookie-content__types">
      <h3 class="cookie-content__title">
        {{ 'cookies-page.cookie-types-title' | translate }}
      </h3>
      <p>
        {{ 'cookies-page.cookie-types-description' | translate }}
      </p>
    <!-- OneTrust Cookies List start -->
    <div id="ot-sdk-cookie-policy"></div>
    <!-- OneTrust Cookies List end -->
    </div>

    <div>
      <h3 class="cookie-content__title">
        {{ 'cookies-page.access-info-title' | translate }}
      </h3>
      <p>{{ 'cookies-page.access-info-description' | translate }}</p>
    </div>

    <div>
      <h3 class="cookie-content__title">
        {{ 'cookies-page.disable-cookies-title' | translate }}
      </h3>
      <p>{{ 'cookies-page.disable-cookies-description-01' | translate }}</p>
      <p>{{ 'cookies-page.disable-cookies-description-02' | translate }}</p>
      <p>{{ 'cookies-page.disable-cookies-description-03' | translate }}</p>
      <ul class="cookie-content__list cookie-content__list--navigators">
        <li>
          {{ 'cookies-page.browser-chrome' | translate }}
          <a [href]="browserChrome" target="_blank">{{ browserChrome }}</a>
        </li>
        <li>
          {{ 'cookies-page.browser-edge' | translate }}
          <a [href]="browserEdge" target="_blank">{{ browserEdge }}</a>
        </li>
        <li>
          {{ 'cookies-page.browser-ie' | translate }}
          <a [href]="browserIe" target="_blank">{{ browserIe }}</a>
        </li>
        <li>
          {{ 'cookies-page.browser-firefox' | translate }}
          <a [href]="browserFirefox" target="_blank">{{ browserFirefox }}</a>
        </li>
        <li>
          {{ 'cookies-page.browser-safari' | translate }}
          <a [href]="browserSafari" target="_blank">{{ browserSafari }}</a>
        </li>
        <li>
          {{ 'cookies-page.browser-opera' | translate }}
          <a [href]="browserOpera" target="_blank">{{ browserOpera }}</a>
        </li>
      </ul>
      <p>{{ 'cookies-page.disable-cookies-warning' | translate }}</p>
    </div>

    <div>
      <h3 class="cookie-content__title">
        {{ 'cookies-page.changes-policy-title' | translate }}
      </h3>
      <p>{{ 'cookies-page.changes-policy-description' | translate }}</p>
    </div>
  </div>
</div>
